import { finalize } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { EnumService } from './../../service/enum/enum';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EnderecoDTO } from '../recadastramento-aba4/endereco.dto';
import { MunicipioDTO } from 'app/model/municipio.dto';
import { Enum } from 'app/model/enum';
import { Observable, forkJoin } from 'rxjs';
import { EnderecoAba4Service } from 'app/service/endereco-aba4/endereco.service';
import { DadosAuxilioTransporte } from 'app/service/dados-transporte-aba12/dados-auxilio-transporte.service';
import { EnderecoViaCep } from 'app/service/enderecoViaCep/enderecoViaCep.service';
import { UserResponse } from 'app/auth/_models/UserResponse';
import { HomeService } from 'app/service/home/home.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ModalDialogComponent } from 'app/components/modal-dialog/modal-dialog.component';
import { MatTable, MatTableDataSource } from '@angular/material/table';

export interface periodo {
  codgLinha: number;
  descLinha: string;
  acoes: string;
}

@Component({
  selector: 'app-recadastramento-aba12',
  templateUrl: './recadastramento-aba12.component.html',
  styleUrls: ['./recadastramento-aba12.component.sass']
})
export class RecadastramentoAba12Component implements OnInit {
  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  formAuxilioTransporte: FormGroup;
  user: UserResponse = null;

  arquivoSelecionadoEndereco: File;
  endereco: EnderecoDTO[];
  descLogradouroOriginal: string;
  numeroLogradouroOriginal: number;
  codTipoLogradouroOriginal: string;
  descComplementoLogradouroOriginal: string;
  descBairroOriginal: string;
  numeroCepLogradouroOriginal: number;
  descricaoMunicipioLogradouroOriginal: string;
  codUfLogradouroOriginal: string;
  municipios: MunicipioDTO[];
  isInfoImportantVisible: boolean = true;
  isInfoImportantVisibleaAuxilio: boolean;
  ufs: Enum[];
  isLoadingSpinner: boolean = true;
  arquivoEnviadoEndereco: boolean = false;
  tiposLogradouros: Enum[];
  tipoLogradouroOriginal: string
  enviandoAnexoEndereco: boolean = false;

  id: number;
  //codgLinhaPrefeitu: string;
  codgLinha: number;
  descLinha: string;
  numePercurso: number;
  flAlterado: string;
  possuiTransporte: string;
  isLoading: boolean = true;
  filterValue: string = '';
  usuarioTemAuxilio: any
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['codgLinhaPrefeitu', 'descLinha', 'acao'];
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageNumber: number = 0;
  pageSize: number = 10;
  totalElements: number = 0;
  pageIndex = -1;

  dialogRef: any;
  selectedLine: any = {};
  linhasVinculadasAoUsuario: number[] = [];
  novasLinhas: number[] = [];
  tamanhoDataSource: number;

  constructor(
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private enumService: EnumService,
    private enderecoService: EnderecoAba4Service,
    private dadosAuxilioTransporte: DadosAuxilioTransporte,
    private enderecoViaCep: EnderecoViaCep,
    private homeService: HomeService,
    private dialog: MatDialog,
  ) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.formAuxilioTransporte = this.formBuilder.group({
      descLogradouro: [''],
      //descTipoLogradouro: ['', [Validators.required]],
      numeroLogradouro: [''],
      descComplementoLogradouro: [''],
      descBairro: [''],
      numeroCepLogradouro: [''],
      descricaoMunicipioLogradouro: [''],
      codUfLogradouro: [''],
      codTipoLogradouro: [''],
      numePercurso: [''],
      //codgLinha: ['', [Validators.required]],
      //descLinha: ['', [Validators.required]],
    });
    this.formAuxilioTransporte.get('descLogradouro')?.disable();
    this.formAuxilioTransporte.get('numeroLogradouro')?.disable();
    this.formAuxilioTransporte.get('descComplementoLogradouro')?.disable();
    this.formAuxilioTransporte.get('descBairro')?.disable();
    this.formAuxilioTransporte.get('numeroCepLogradouro')?.disable();
    this.formAuxilioTransporte.get('codUfLogradouro')?.disable();
    this.formAuxilioTransporte.get('descricaoMunicipioLogradouro')?.disable();
  }

  ngOnInit(): void {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.homeService.getLotacaoeFoto().subscribe(resp => {
      this.user.lotacao = resp.lotacao;
    })
    this.formAuxilioTransporte.get('numeroCepLogradouro').valueChanges.subscribe(() => {
      this.buscarCep();
    });

    this.processarEndereco();
  }

  valorPercurso(): void {
    this.formAuxilioTransporte.get('numePercurso').setValue(this.dataSource.data.length)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mostrarAlerta) {
      this.isInfoImportantVisible = true
    }
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  toggleInfoImportantVisibleAuxilio() {
    this.isInfoImportantVisibleaAuxilio = !this.isInfoImportantVisibleaAuxilio;
  }

  private processarEndereco(): void {
    this.isLoadingSpinner = true;
    const endereco$: Observable<EnderecoDTO> = this.getEndereco();
    const ufs$: Observable<Enum[]> = this.getUfs();
    const tipoLogradouro$: Observable<Enum[]> = this.buscarTipoLogradouro();
    const verificar$: Observable<Enum[]> = this.verificaSeOUsuarioTemAuxilio();
    const pagina = this.pageIndex + 1; // pageIndex é baseado em zero, então adicionamos 1
    const tamanho = this.pageSize;
    const todasLinhasTransporte$: Observable<Enum[]> = this.getLinhasViculadasAoUsuario(pagina, tamanho);
    forkJoin([endereco$, ufs$, tipoLogradouro$, verificar$, todasLinhasTransporte$])
      .pipe(finalize(() => this.isLoadingSpinner = false))
      .subscribe(
        ([endereco, ufs, tipoLogradouro, verificar, todasLinhasTransporte]) => {
          todasLinhasTransporte['content'].forEach(codgLinha => {
            this.linhasVinculadasAoUsuario.push(codgLinha)

          })
          this.atualizarFormulario(endereco, ufs, tipoLogradouro, verificar, todasLinhasTransporte);
        },
        (error) => {
          //this.mostrarMensagem('Ocorreu um erro ao carregar os dados. Por favor, tente novamente.');
        }
      );
  }

  private getEndereco(): Observable<EnderecoDTO> {
    return this.enderecoService.getEnderecoPessoal();
  }
  private getUfs(): Observable<Enum[]> {
    return this.enumService.buscarUF();
  }

  private buscarTipoLogradouro(): Observable<Enum[]> {
    return this.enumService.buscarTipoLogradouro();
  }

  private verificaSeOUsuarioTemAuxilio(): Observable<any> {
    return this.dadosAuxilioTransporte.getVerificaSeOUsuarioTemAuxilio();
  }


  private atualizarFormulario(endereco: EnderecoDTO, ufs: Enum[], tipoLogradouro: Enum[], verificar: any, todasLinhasTransporte: Enum[]): void {
    this.arquivoEnviadoEndereco = endereco.anexoEndereco
    this.tipoLogradouroOriginal = endereco.descLogradouro;
    this.descLogradouroOriginal = endereco.descLogradouro;
    this.numeroCepLogradouroOriginal = endereco.numeroCepLogradouro;
    this.codTipoLogradouroOriginal = endereco.codTipoLogradouro.trim();
    this.numeroLogradouroOriginal = endereco.numeroLogradouro;
    this.descComplementoLogradouroOriginal = endereco.descComplementoLogradouro;
    this.descBairroOriginal = endereco.descBairro;
    this.descricaoMunicipioLogradouroOriginal = endereco.descricaoMunicipioLogradouro;
    this.codUfLogradouroOriginal = endereco.codUfLogradouro;
    this.formAuxilioTransporte.patchValue({
      descLogradouro: endereco.descLogradouro,
      numeroLogradouro: endereco.numeroLogradouro,
      descComplementoLogradouro: endereco.descComplementoLogradouro,
      descBairro: endereco.descBairro,
      numeroCepLogradouro: endereco.numeroCepLogradouro,
      descricaoMunicipioLogradouro: endereco.descricaoMunicipioLogradouro,
      codUfLogradouro: endereco.codUfLogradouro,
      codTipoLogradouro: endereco.codTipoLogradouro.trim()
    });
    this.tiposLogradouros = tipoLogradouro
    this.ufs = ufs;
    this.usuarioTemAuxilio = verificar.possuiAuxilioTransporte
    this.flAlterado = verificar.permiteAlterarAuxilioTransporte ? 'S' : 'N'
    if (!this.usuarioTemAuxilio) {
      this.isInfoImportantVisibleaAuxilio = true
    }
    this.tamanhoDataSource = (todasLinhasTransporte['content'].length)
    this.dataSource.data = todasLinhasTransporte['content'];
    this.totalElements = todasLinhasTransporte['totalElements'];
    this.valorPercurso()
  }

  buscarCep(): void {
    const numeroCepLogradouro = this.formAuxilioTransporte.get('numeroCepLogradouro').value;

    if (numeroCepLogradouro && numeroCepLogradouro.toString().length === 8) {
      this.enderecoViaCep.buscarEnderecoViaCep(numeroCepLogradouro).subscribe((data: any) => {
        if (this.formAuxilioTransporte.get('numeroCepLogradouro').dirty) {
          // O campo CEP foi modificado pelo usuário, atualize os campos com os dados do ViaCEP
          this.formAuxilioTransporte.patchValue({
            descLogradouro: data.logradouro,
            descBairro: data.bairro,
            codUfLogradouro: data.uf,
            descricaoMunicipioLogradouro: data.localidade,
          });
        }
      });
    }
    this.enderecoViaCep.buscarEnderecoViaCep(numeroCepLogradouro).subscribe((data: any) => {
      this.formAuxilioTransporte.patchValue({
        descricaoMunicipioLogradouro: data.localidade,
      });

    });
  }
  filtrarMunicipiosPorLocalidade(localidade: string) {
    const localidadeLowerCase = localidade.toLowerCase(); // Converter para letras minúsculas
    const localidadeMunicipio = this.municipios.find(municipio => municipio.descricao.toLowerCase() === localidadeLowerCase);
    return localidadeMunicipio ? localidadeMunicipio.codigo : null;
  }

  visualizarComprovanteEndereco(): void {
    this.enderecoService.getArquivo().subscribe((response: Blob) => {
      const fileName = 'Comprovante_Endereco';
      const fileType = this.getFileTypeFromBlob(response);
      if (fileType === null) {
        return;
      }

      const blob = new Blob([response], { type: fileType });
      // Inicia o download do arquivo
      saveAs(blob, fileName + '.' + fileType);
    }, error => {
      this.toasterService.warning('Erro ao fazer o download do arquivo');
    });
  }

  private getFileTypeFromBlob(blob: Blob): string | null {
    if (blob.type) {
      const contentType = blob.type.toLowerCase();
      if (contentType.includes('pdf')) {
        return 'pdf';
      } else if (contentType.includes('jpeg') || contentType.includes('jpg')) {
        return 'jpeg';
      } else if (contentType.includes('png')) {
        return 'png';
      }
    }
    return null;
  }

  private getLinhasViculadasAoUsuario(pagina, tamanho): Observable<any> {
    return this.dadosAuxilioTransporte.getLinhasViculadasAoUsuario(pagina, tamanho)
  }

  extractFileName(contentDispositionHeader: string): string {
    const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = fileNameRegex.exec(contentDispositionHeader);
    if (matches != null && matches[1]) {
      return matches[1].replace(/['"]/g, '');
    }
    return '';
  }

  extractFileExtension(fileName: string): string {
    const fileExtensionRegex = /(?:\.([^.]+))?$/;
    const matches = fileExtensionRegex.exec(fileName);
    if (matches != null && matches[1]) {
      return matches[1].toLowerCase();
    }
    return '';
  }

  verificarQuantidadePercursos() {
    const quantidadePercursosServidor = this.formAuxilioTransporte.get('numePercurso').value;
    if (quantidadePercursosServidor > 6) {
      this.formAuxilioTransporte.controls.numePercurso.reset()
      this.toasterService.warning('Atenção: Quantidade máxima permitida 6 percursos!')
    }
  }

  openModal() {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      width: '600px',
      height: '90%',
      data: {
        totalElements: this.totalElements,
        pageSize: this.pageSize
      }
    });
    dialogRef.componentInstance.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe(result => {
      if (result != '' || result != undefined) {
        this.selectedLine = result;
        this.atualizarTableComLinhasSelecionadas(result)
      }
    });
  }

  private atualizarTableComLinhasSelecionadas(result) {
    const linhaExistente = this.dataSource.data.find(element => element.id == result.id);
    if(this.dataSource.data.length === 6) {
      this.toasterService.warning('Atenção: Quantidade máxima permitida 6 percursos!')
      return 
    }
    if (!linhaExistente) {
      this.novasLinhas.push(result.id);
      this.dataSource.data.unshift(result);
      this.dataSource.data = [...this.dataSource.data];
      this.tamanhoDataSource = this.dataSource.data.length
      this.formAuxilioTransporte.value.numePercurso = this.tamanhoDataSource
      this.valorPercurso()
    } else {
      this.toasterService.warning('Linha já foi incluída.')
    }
  }

  excluirElemento(id: number) {
    const linhaTransporte = this.linhasVinculadasAoUsuario.find(linha => linha['id'] === id);
    if (linhaTransporte) {
      // O elemento já existe em this.linhasVinculadasAoUsuario e precisa ser excluído no backend
      this.dadosAuxilioTransporte.excluirLinha(id).subscribe(
        (response) => {
          this.toasterService.success('Linha excluída com sucesso');
          this.dataSource.data = this.dataSource.data.filter(element => element.id !== id);
          this.dataSource.data = [...this.dataSource.data];
          this.tamanhoDataSource = this.dataSource.data.length
          this.limparNovasLinhas(id)
          this.valorPercurso()
        },
        (error) => {
          console.error('Erro ao atualizar os dados', error);
        }
      );

      // Após a exclusão bem-sucedida no backend, atualize this.linhasVinculadasAoUsuario
      const index = this.linhasVinculadasAoUsuario.indexOf(linhaTransporte);
      if (index !== -1) {
        this.linhasVinculadasAoUsuario.splice(index, 1);
        this.valorPercurso()
      }
    } else {
      // O elemento não existe em this.linhasVinculadasAoUsuario, pode ser excluído diretamente de this.dataSource.data
      const index = this.dataSource.data.findIndex(elemento => elemento.id === id);
      if (index !== -1) {
        
        this.dataSource.data.splice(index, 1);
        this.dataSource.data = [...this.dataSource.data]; // Atualize o dataSource para refletir as alterações na tabela
        this.toasterService.success('Linha excluída com sucesso');
        this.valorPercurso()
        this.limparNovasLinhas(id)

      }
    }
  }

  checkCEP() {
    if (this.numeroCepLogradouroOriginal != this.formAuxilioTransporte.value.numeroCepLogradouro) {
      return true
    } else {
      return false
    }
  }

  checkTipoLogradouro() {
    if (this.codTipoLogradouroOriginal != this.formAuxilioTransporte.value.codTipoLogradouro) {
      return true
    } else {
      return false
    }
  }

  checkDescLogradouro() {
    const descricaologradouro = this.formAuxilioTransporte.value.descLogradouro
    if (this.descLogradouroOriginal != descricaologradouro) {
      return true
    } else {
      return false
    }
  }

  checkNumLogradouro() {
    const numerologradouro = this.formAuxilioTransporte.value.numeroLogradouro

    if ((this.numeroLogradouroOriginal) !== (numerologradouro)) {
      return true;
    } else {
      return false;
    }
  }
  checkDescBairro() {
    const bairro = this.formAuxilioTransporte.value.descBairro

    if (this.descBairroOriginal != bairro) {
      return true
    } else {
      return false
    }
  }
  checkUF() {
    if (this.codUfLogradouroOriginal != this.formAuxilioTransporte.value.codUfLogradouro) {
      return true
    } else {
      return false
    }
  }
  checkExisteIdLinha() {
    if (this.novasLinhas.length > 0 || this.dataSource.data.length > 0) {
      return true
    } else {
      return false
    }
  }

  limparNovasLinhas(id: number) {
    // Filtra o array para remover o elemento com o valor igual a 'id'
    this.novasLinhas = this.novasLinhas.filter((numero) => numero !== id);
  }

  adicionarValidacaoRequired() {
    if (this.flAlterado != 'N' || this.usuarioTemAuxilio == true) {
      const campoControl = this.formAuxilioTransporte.get('numePercurso') as FormControl;
      campoControl.setValidators([Validators.required]);
      campoControl.updateValueAndValidity();
    }
  }

  atualizarTransporte() {
    if (this.usuarioTemAuxilio == true) {

      if (this.formAuxilioTransporte.valid) {
        // Lógica para enviar os dados do formulário

        this.dadosAuxilioTransporte.salvar(this.novasLinhas, this.formAuxilioTransporte.value.numePercurso).subscribe(
          (response) => {
            this.toasterService.success('Dados atualizados com sucesso');
            //this.limparNovasLinhas()
            this.dadosSalvos.emit();
            this.formularioSalvo.emit();
          },
          (error) => {
            console.error('Erro ao atualizar os dados', error);
          }
        );
      } else {
        this.toasterService.warning('Atenção: Todos os campos marcados com (*) são obrigatórios!');
      }
    } else {
      this.dadosSalvos.emit();
      this.formularioSalvo.emit();
    }


  }

  onArquivoExcluidoEndereco(mensagem) {
    const input = document.getElementById('input-file-endereco') as HTMLInputElement;
    if (mensagem) {
      this.enderecoService.deletarComprovanteEndereco().subscribe(resp => {
        this.toasterService.success('Arquivo excluído com sucesso');
        this.arquivoEnviadoEndereco = false
        this.arquivoSelecionadoEndereco = null;
      }, error => {
        this.toasterService.error('Erro ao excluir comprovante');
      });
    } else {
      input.value = '';
      this.arquivoEnviadoEndereco = false
      this.arquivoSelecionadoEndereco = null;
    }

  }

  enviarAnexoEndereco() {
    this.enviandoAnexoEndereco = true
    if (this.arquivoSelecionadoEndereco) {
      this.toasterService.info('Enviando arquivo. Por favor, aguarde.');
      this.enderecoService.salvarEnderecoPessoal(this.arquivoSelecionadoEndereco).subscribe(
        (response) => {
          this.toasterService.success('Arquivo enviado');
          this.arquivoEnviadoEndereco = true
          this.enviandoAnexoEndereco = false
        },
        (error) => {
          this.arquivoEnviadoEndereco = false
          if (error.status == 422) {
            this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
          } else {
            this.toasterService.error('Erro ao enviar o anexo');
          }
          this.onArquivoExcluidoEndereco(false)

        }
      );
    }
  }

  onArquivoSelecionado(event: any, TipoDocumento: string) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];

    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
      switch (TipoDocumento) {
        case 'endereco':
          this.arquivoSelecionadoEndereco = file;
          this.enviarAnexoEndereco();
          break;
      }

    }
    else {
      this.arquivoSelecionadoEndereco = null;

      if (!allowedFileTypes.includes(file.type)) {
        this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
      } else if (file.size > maxFileSizeInBytes) {
        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
      }
      this.onArquivoExcluidoEndereco(false)
    }

  }

  avancaParaProximoTab() {
    this.dadosSalvos.emit()

  }
  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }



}

